import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import {Row, Col} from 'react-flexbox-grid'
import config from '../../config'
import format from '../../helpers/format'
import analytics from '../../helpers/analytics'
import {
  Link,
} from '../../components'
import Styles from './FamilyGrid.css'

@CSSModules(Styles)
export default class FamilyGrid extends Component {
  static propTypes = {
    fullGrid: PropTypes.bool
  }
  constructor(props){
    super(props)
  }

  onMouseEnter = (prop) => {
    return () => {
      // this.state.onHovers[prop] = true
      const onHovers = Object.assign({},this.state.onHovers)
      onHovers[prop] = true
      this.setState({onHovers: onHovers})
      // console.log('enter:',onHovers )
    }
  }

  onMouseLeave = (prop) => {
    return () => {
      const onHovers = Object.assign({},this.state.onHovers)
      delete onHovers[prop]
      this.setState({onHovers: onHovers})
      // console.log('leave:',onHovers )
      // console.log('leave:',this.state.onHovers )
    }
  }

  renderCompanies = () => {
    return config.familyFunds.map((c,idx) =>{
      return this.renderCompany(idx, c)
    })
  }

  renderLogo = (title) => {
    const fileName = format.imgPath(title)
    let hasLogo = false
    let companyLogo = null
    try {
      companyLogo = require('../../../static/images/fam/'+fileName+'.png')
      hasLogo = true
    }
    catch (e) {
      console.log('')
    }
    if (hasLogo) {
      return (
        <img
          styleName='box-title-logo'
          src={companyLogo}
          alt={title}
        />
      )
    } else {
      // console.log(fileName)
      return (
        <span>{title}</span>
      )
    }
  }

  renderCompany = (idx, c) => {
    const { name, gef_score_norm, dei_score_norm, rji_score_norm, hrc_score_norm } = c

    const epsilonRound = (x, multiplier=1) => {
      return Math.round(((x * multiplier) + Number.EPSILON) * 10) / 10
    }
    const safeName = encodeURIComponent(name)
    return <Col key={idx} styleName='companies-box-wrap' xs={12} sm={4}>
      <Link
        onMouseEnter={this.onMouseEnter('company-'+idx)}
        onMouseLeave={this.onMouseLeave('company-'+idx)}
        log={analytics.eventToFamily(name)}
        to={config.routes.families+'?q='+safeName}
        styleName='companies-link'
        title={name}
      >
        <div styleName='companies-box'>
          <div styleName='box-title-wrapper'>
            { this.renderLogo(name) }
          </div>
          { /* <div styleName='box-subtitle'>
            Equity funds analyzed: <strong>{num_funds}</strong>
          </div> */ }
          { /* <div styleName='box-subtitle'>
            Fund assets analyzed, USD: <strong>{format.money(net_assets,true,'USD',true,1)}</strong>
          </div> */ }
          { /* <div styleName='box-subtitle'>
            &mdash;
          </div> */ }
          { /* <div styleName='box-subtitle'>
             Sustainable funds: <strong>{sri}</strong>
          </div> */ }


          {/* <div styleName='box-subtitle'>
            Gender equality: <strong>{epsilonRound(gef_score_norm)}</strong> / 100
          </div>
          <div styleName='box-subtitle'>
            Diversity disclosures: <strong>{epsilonRound(dei_score_norm)}</strong> / 100
          </div>
          <div styleName='box-subtitle'>
            Racial justice: <strong>{epsilonRound(rji_score_norm)}</strong> / 100
          </div>
          <div styleName='box-subtitle'>
            LGBTQ+ equity: <strong>{epsilonRound(hrc_score_norm)}</strong> / 100
          </div> */}

          <div styleName='learn-more-wrap'>
            <div styleName='learn-more'>
              See fund ratings <i className='fa fa-angle-double-right'/>
            </div>
          </div>

        </div>
      </Link>
    </Col>
  }

  renderAddtl = () => {
    if (!this.props.fullGrid) {
      return null
    }

    const allFams = config.formOptions.fundFamilyAll
    const filteredFams = allFams.reduce((arr, el) => {
      if (el.name !== 'All funds') {
        arr.push(el)
      }
      return arr
    }, [])

    return (
      <div>
        <div styleName='addtl-fam-info'>
          <strong>
            We analyze funds from over one hundred asset managers.
            &nbsp;
            See the full list below:
          </strong>
        </div>
        <div styleName='addtl-fam-links'>
          { filteredFams.map( (el, ix) => {
            return (
              <Link
                to={config.routes.families+'?q='+el.name}
                title={el.name}
                key={el.name}
                xstrong
              >
                <div styleName='addtl-fam-link'>

                  { /* <div styleName='addtl-fam-link-logo'>
                    { this.renderLogo(el.name, el.name) }
                  </div> */ }

                  <div styleName='addtl-fam-link-lbl'>
                    { el.name }
                  </div>

                </div>
              </Link>
            )
          }) }
        </div>
      </div>
    )
  }

  render() {
    return <div styleName='companies'>
      <div styleName='companies-anchor' id='companies'/>
      <div styleName='companies-inner'>
        <div styleName='companies-title'>
          Are fund managers investing in social justice?
        </div>
        <div styleName='companies-info'>
          Are your savings invested with one of these financial giants?
          Find out how the funds they offer
          stack up.
        </div>
        <Row styleName='companies-boxes'>
          { this.renderCompanies() }
        </Row>
        { this.renderAddtl() }
      </div>
    </div>
  }
}
